import { Location } from 'react-router';

export const referrerParameter = 'referrer';
const ignoredRoutes = new Set(['/login', '/loginRedirect', '/page-not-found']);

export const createReferrerParameters = (location: Location | string) => {
  let url = '';
  switch (typeof location) {
    case 'string':
      url = location;
      break;

    default:
      url = `${location.pathname}${location.search}`;
      break;
  }

  if (ignoredRoutes.has(url)) {
    return;
  }

  const encodedUrl = window.btoa(url);

  return `?${referrerParameter}=${encodedUrl}`;
};
